import { render, staticRenderFns } from "./TeamHomeRtl.vue?vue&type=template&id=59464ca7&"
import script from "./TeamHomeRtl.vue?vue&type=script&lang=js&"
export * from "./TeamHomeRtl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports